import script from "./TransfereView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransfereView.vue?vue&type=script&setup=true&lang=js"

import "./TransfereView.vue?vue&type=style&index=0&id=7fa88d83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa88d83"]])

export default __exports__